import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable({ providedIn: 'root' })
export class ReloadNotificationAnalytics extends AnalyticsBase {
  public readonly namespace = 'FloatingReloadComponent';
  public readonly requireViewContext = false;

  public trackComponentActions(actionType: 'show' | 'dismiss' | 'reload') {
    this.track('action', {
      actionType,
    });
  }
}
